export type DataFilterInputType =
  | "Undefined"
  | "TextBox"
  | "CheckBox"
  | "EnumCheckBox"
  | "RangeBox"
  | "RangeBoxCurrency"
  | "DateRangeBox"
  | "EnumRadioBox"
  | "SelectInputBox"
  | "EnumSelectInputBox"
  | "SelectInputBoxCurrency"
  | "RadioInputBox";

export const DataFilterInputType = {
  Undefined: "Undefined" as DataFilterInputType,
  TextBox: "TextBox" as DataFilterInputType,
  CheckBox: "CheckBox" as DataFilterInputType,
  EnumCheckBox: "EnumCheckBox" as DataFilterInputType,
  RangeBox: "RangeBox" as DataFilterInputType,
  RangeBoxCurrency: "RangeBoxCurrency" as DataFilterInputType,
  DateRangeBox: "DateRangeBox" as DataFilterInputType,
  EnumRadioBox: "EnumRadioBox" as DataFilterInputType,
  SelectInputBox: "SelectInputBox" as DataFilterInputType,
  EnumSelectInputBox: "EnumSelectInputBox" as DataFilterInputType,
  SelectInputBoxCurrency: "SelectInputBoxCurrency" as DataFilterInputType,
  RadioInputBox: "RadioInputBox" as DataFilterInputType
};
